import React, { useState } from 'react'

import styled from '@emotion/styled'
import get from 'lodash/get'

import { useCreateRole, useStackRoles } from 'data/hooks/roles'
import { FormLabel, Input, Text } from 'legacy/v1/ui/index'

import { Button } from 'v2/ui'

export const PermissionsRolesPage = ({ onSubmit }) => {
    const { data: roles } = useStackRoles()
    const { mutateAsync: createRole } = useCreateRole()

    const defaultState = {
        newRoleModalOpen: false,
        confirmModalError: false,
        confirmModalProcessing: false,
        newRoleLabel: '',
        newRoleValue: '',
        duplicateNameError: false,
        duplcateValueError: false,
    }

    const [state, setState] = useState(defaultState)

    const isNameDuplicate = (name) => {
        return roles.some((role) => role.label === name)
    }

    return (
        <>
            <h3>Add a new role</h3>
            <FlexWrapper>
                <Label htmlFor="role-name">Name</Label>
                <Input
                    value={state.newRoleLabel}
                    onChange={(event) => setState({ ...state, newRoleLabel: event.target.value })}
                    id="role-name"
                    style={{ flex: 1 }}
                />
            </FlexWrapper>
            {state.confirmModalError && (
                <Text style={{ color: '#e74c3c' }}>
                    Sorry, there was an error creating this new role. Please try again.
                </Text>
            )}
            {state.duplicateNameError && (
                <Text style={{ color: '#e74c3c' }}>
                    A role already exists with this name. Please choose another name.
                </Text>
            )}
            {state.duplicateValueError && (
                <Text style={{ color: '#e74c3c' }}>
                    A role already exists with this value. Please choose another value.
                </Text>
            )}
            <Button
                variant="adminPrimary"
                buttonSize="sm"
                mt={4}
                onClick={() => {
                    setState({
                        ...state,
                        confirmModalError: false,
                        duplicateNameError: false,
                        duplicateValueError: false,
                        confirmModalProcessing: true,
                    })
                    if (isNameDuplicate(state.newRoleLabel)) {
                        setState({
                            ...state,
                            duplicateNameError: true,
                            confirmModalProcessing: false,
                        })
                        return
                    }

                    createRole({
                        label: state.newRoleLabel,
                        type_value: null,
                        options: { type: 'internal' },
                    })
                        .then(onSubmit)
                        .catch((e) => {
                            console.error(`Error adding a new role: ${get(e, 'message')}`)
                            setState({
                                ...state,
                                confirmModalError: true,
                                confirmModalProcessing: false,
                            })
                        })
                }}
            >
                Confirm
            </Button>
        </>
    )
}

const FlexWrapper = styled('div')`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
`

const Label = styled(FormLabel)`
    text-align: left;
    margin-right: 20px;
    width: 60px;
`
